<script context="module" lang="ts">
	import Dropdown from '$lib/components/inputs/Dropdown.svelte';
	import Section from '$lib/components/layout/Section.svelte';
	import type { SectionConfig } from '$lib/util/pagebuilder';
	import { gql } from 'graphql-request';
	import Button from '$lib/components/util/Button.svelte';

	export const config: SectionConfig = {
		collection: 'section_subscription_hero',
		availableFor: ['pages'],
		query: gql`
		id
        internal_name
        translations {
            languages_code {
                code 
            }
            title
            text
        }
        items {
            section_subscription_hero_item_id {
                icon {
                    ...Media
                }
                translations {
                    languages_code {
                        code
                    }
                    title
                }
            }   
        }
		subscriptions {
			subscription_id {
				media {
					...Media
				}
				translations {
					languages_code {
						code
					}
					title
				}
			}
		}

    `
	};

	// optional: define a type for the props (note: injectTranslations is applied)
	type Props = {
		id: string;
		section_title: string;
		title: string;
		text: string;
		items: any;
		subscriptions: any;
	};
</script>

<script lang="ts">
	import Wysiwyg from '$lib/components/inputs/WYSIWYG.svelte';
	import Media from '$lib/components/media/Media.svelte';
	import Text from '$lib/components/Text.svelte';
	import Slider from '$lib/components/util/Slider.svelte';
	import type { SwiperOptions } from 'swiper/types/swiper-options';
	import SubscriptionCard from '$lib/components/ecom/SubscriptionCard.svelte';

	export let data: Props; // the components gets all data via this prop (additionally each top level prop is directly provided to the component)

	const swiperOptions: SwiperOptions = {
		loop: false,
		centeredSlides: false,
		initialSlide: 0,
		spaceBetween: 20
	};
</script>

<Section gapType="padding" class="section-subscription-hero">
	<div slot="background" class="background" />
	<div class="wrapper">
		<div class="col1">
			<div class="title">
				{data.title}
			</div>
			<div class="divider" />
			<div class="text"><Wysiwyg text={data.text} /></div>
			<div class="content">
				{#each data.items as { section_subscription_hero_item_id: item }}
					<div class="container">
						<div class="icon-wrapper"><Media {...item.icon} fit="cover" transform="l" /></div>
						<div class="item-text">{item.title}</div>
					</div>
				{/each}
			</div>
		</div>
		<div class="col2">
			<div class="subscriptions subscriptions-desktop">
				{#each data.subscriptions as { subscription_id: subscription }, index}
					{#if index === 0}
						<SubscriptionCard media={subscription.media} title={subscription.title} />
						<div class="separator">or</div>
					{/if}
					{#if index === 1}
						<SubscriptionCard
							media={subscription.media}
							title={subscription.title}
							special={true}
						/>
					{/if}
				{/each}
			</div>
			<!-- <div class="subscriptions subscriptions-mobile">
				<Slider
					name="subscription-hero-{data.id}"
					type="single"
					navigation={false}
					pagination={true}
					slidesPerView={1.2}
					slidesPerViewPhone={1.2}
					centeredSlides={false}
					options={swiperOptions}
				>
					{#each data.subscriptions as { subscription_id: subscription }, index}
						<div class="swiper-slide">
							{#if index === 0}
								<SubscriptionCard media={subscription.media} title={subscription.title} />
							{/if}
							{#if index === 1}
								<SubscriptionCard
									media={subscription.media}
									title={subscription.title}
									special={true}
								/>
							{/if}
						</div>
					{/each}
				</Slider>
				<div />
			</div> -->
		</div>
	</div>
</Section>

<style lang="scss">
	:global(.section-subscription-hero) {
		:global(.background) {
			background: color(yellow);
		}
	}

	.wrapper {
		display: grid;
		grid-template-columns: repeat(2, minmax(0, 1fr));
		gap: v(content-gap-sm);
		@media (max-width: 1200px) {
			grid-template-columns: repeat(1, minmax(0, 1fr));
		}
	}
	.title {
		@include font(h1);
		margin-bottom: v(content-gap-xl);
		max-width: 12ch;
	}
	.divider {
		width: 2.8rem;
		height: 3px;
		background: color(black);
		margin-top: -0.1rem;
	}
	.text {
		@include font(text-lg);
		padding: v(content-gap-sm) 0;
		max-width: 50ch;
	}
	.icon-wrapper {
		width: 40px;
		height: 1em;
		object-fit: contain;
	}
	.content {
		display: flex;
		flex-direction: column;
		gap: v(content-gap);
	}
	.container {
		display: flex;
		align-items: center;
		gap: v(content-gap);
	}
	.item-text {
		text-transform: uppercase;
		@include font(h5);
	}

	.subscriptions-desktop {
		display: flex;
		gap: v(content-gap);
		@include media(phone) {
			// display: none;
			flex-direction: column;
			gap: v(content-gap-lg);
		}
	}

	.subscription-card {
		padding: v(content-gap-sm);
		width: 100%;
		height: 100%;
		border: solid blue;
		&:first-child {
			background: color(white);
		}
		&:nth-child(3) {
			margin-top: v(content-gap-2xl);
			background: color(yellow_02);
			border: solid blue;
		}
		@include media(tablet) {
			// margin-bottom: v(content-gap-xl);
			&.special {
				background: color(yellow_02);
			}
		}
	}
	.separator {
		@include font(h4);
		align-items: center;
		display: flex;
		@include media(phone) {
			display: none;
		}
	}
	.subscription-title {
		@include font(h4);
	}

	.content {
		padding: v(content-padding-sm) 0;
	}
	.subscripion-settings {
		display: flex;
		flex-direction: column;
		gap: v(content-gap);
		.option {
			display: flex;
			flex-direction: column;
			gap: v(content-gap-xs);
			@include font(h6);
			width: 100%;
			align-items: start;
			span {
				display: flex;
				width: 100%;
				white-space: nowrap;
			}
		}
		:global(.dropdown) {
			max-width: 100%;
			padding: 0 !important;
			height: 2rem !important;
		}

		&.special {
			:global(.dropdown) {
				:global(select) {
					background: color(white) !important;
				}
			}
		}
	}
	.subscribe-button {
		:global(button) {
			width: 100%;
			display: flex;
			justify-content: center;
		}
	}

	.subscriptions-mobile {
		display: none;
		@include media(phone) {
			display: block;
			position: relative;
		}
		:global(.swiper-pagination) {
			position: absolute !important;
			bottom: 0;
		}
	}
</style>
